import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

import TextField from 'app/commonComponents/TextField';
import PasswordInput from 'app/commonComponents/PasswordInput';

function FormField({
  name,
  type,
  label,
  required = true,
  ignoreError = () => false,
  ...rest
}) {
  const { values, errors, touched, setFieldValue, setFieldTouched } =
    useFormikContext();
  const error = errors[name];
  const isTouched = touched[name];
  const showError =
    !!error &&
    typeof error === 'string' &&
    isTouched &&
    !ignoreError(name, error);
  const props = {
    name,
    required,
    label: label && `${label}${required ? ' *' : ''}`,
    value: values[name],
    onChange: (e) => {
      setFieldValue(name, e.target.value);
      if (isTouched) {
        setFieldTouched(name, false, false); // we want the error message to disappear on change but keep the error itself
      }
    },
    onBlur: () => setFieldTouched(name, true, false),
    style: { marginBottom: '1rem' },
    error: showError && error,
    ...rest,
  };
  return type === 'password' ? (
    <PasswordInput {...props} />
  ) : (
    <TextField {...props} />
  );
}

FormField.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  ignoreError: PropTypes.func,
};

export default FormField;
